module.exports = __webpack_public_path__ + "img/10.c104a465.jpg";